export default "__VITE_ASSET__BhZINc3Q__"